var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "home" } },
    [
      _c("home-front-pages", {
        ref: "FrontPages",
        attrs: { "svc-pages": _vm.svcPages },
      }),
      _vm.articles && _vm.articles.length
        ? _c("home-articles", {
            ref: "Articles",
            staticClass: "contents",
            attrs: { items: _vm.articles },
          })
        : _vm._e(),
      _vm.events && _vm.events.length
        ? _c("home-events", {
            ref: "Events",
            staticClass: "contents",
            attrs: { items: _vm.events },
          })
        : _vm._e(),
      _vm.actors && _vm.actors.length
        ? _c("home-actors", {
            ref: "Actors",
            staticClass: "contents",
            attrs: { items: _vm.actors },
          })
        : _vm._e(),
      _vm.collections && _vm.collections.length
        ? _c("home-collections", {
            ref: "Collections",
            staticClass: "contents",
            attrs: { items: _vm.collections },
          })
        : _vm._e(),
      _vm.artworks && _vm.artworks.length
        ? _c("home-artworks", {
            ref: "Artworks",
            staticClass: "contents",
            attrs: { items: _vm.artworks },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }